import { createAction } from 'redux-actions';
import { RefundOperation } from '../types';

export const SET_REFUND_LOADING = 'REFUND/SET_REFUND_LOADING';

export const setRefundLoading = createAction(SET_REFUND_LOADING, (operation: RefundOperation, status: boolean) => ({
	operation,
	status
}));

export type SetRefundLoadingAction = ReturnType<typeof setRefundLoading>;

export type ActionLoadingTypes = SetRefundLoadingAction;
